import type { AttentionOrigin, RoleCode } from './types';

export const STUDY_ORIGIN_ACCESS: Record<AttentionOrigin, RoleCode[]> = {
  CONSULTORIO: ['RECEPCION', 'TECNICA', 'MEDICO', 'COORDINACION', 'ADMINISTRADOR'],
  CLINICA_EXTERNA: ['TECNICA', 'MEDICO', 'COORDINACION', 'ADMINISTRADOR'],
};

export const ROLE_ACCESS: Record<'patientManage' | 'studyCreate' | 'reception' | 'technicalCapture' | 'technical' | 'medical' | 'clinicalTemplates' | 'documents' | 'billing' | 'admin', RoleCode[]> = {
  patientManage: ['RECEPCION', 'TECNICA', 'COORDINACION', 'ADMINISTRADOR'],
  studyCreate: ['RECEPCION', 'TECNICA', 'MEDICO', 'COORDINACION', 'ADMINISTRADOR'],
  reception: ['RECEPCION', 'COORDINACION', 'ADMINISTRADOR'],
  technicalCapture: ['TECNICA', 'MEDICO', 'COORDINACION', 'ADMINISTRADOR'],
  technical: ['TECNICA', 'MEDICO', 'COORDINACION', 'ADMINISTRADOR', 'SUPERVISOR'],
  medical: ['MEDICO', 'COORDINACION', 'ADMINISTRADOR', 'AUDITOR', 'SUPERVISOR'],
  clinicalTemplates: ['MEDICO', 'COORDINACION', 'ADMINISTRADOR'],
  documents: ['MEDICO', 'COORDINACION', 'ADMINISTRADOR', 'SUPERVISOR'],
  billing: ['FACTURACION', 'COORDINACION', 'ADMINISTRADOR', 'AUDITOR', 'SUPERVISOR'],
  admin: ['ADMINISTRADOR', 'COORDINACION', 'AUDITOR'],
};
